import AddVideoModalContainer from 'components/AddVideoModal/AddVideoModalContainer'

export default {
  Container: AddVideoModalContainer,
}
